// fps.js
var Fps = pc.createScript('fps');

Fps.prototype.initialize = function () {
    this.array = [];
};

// Called every frame, dt is time in seconds since last update
Fps.prototype.update = function (dt) {
    if (dt) {
        var fps = 1/dt;
        this.array.push(fps);
    }
       
     var sum = 0;
     for(var i = 0; i < this.array.length; i++) {
         sum += this.array[i];
    }
    
    if (this.array.length) {
        sum /= this.array.length;        
    }
    
    if (this.array.length > 100) {
        this.array.shift();
    }
    
    this.entity.element.text = sum.toFixed(2);  
    
    //console.log(this.entity.element);
};


